"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _ExclamationTriangle = _interopRequireDefault(require("./ExclamationTriangle/ExclamationTriangle"));

var _SuccessMark = _interopRequireDefault(require("./SuccessMark/SuccessMark"));

var _Available = _interopRequireDefault(require("./Available/Available"));

var _excluded = ["isAgentAvailable", "hasErrorMark", "hasSuccessMark", "hasNarrowBottom", "hasLargeBottom", "className", "children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Title = function Title(_ref) {
  var _ref$isAgentAvailable = _ref.isAgentAvailable,
      isAgentAvailable = _ref$isAgentAvailable === void 0 ? false : _ref$isAgentAvailable,
      _ref$hasErrorMark = _ref.hasErrorMark,
      hasErrorMark = _ref$hasErrorMark === void 0 ? false : _ref$hasErrorMark,
      _ref$hasSuccessMark = _ref.hasSuccessMark,
      hasSuccessMark = _ref$hasSuccessMark === void 0 ? false : _ref$hasSuccessMark,
      _ref$hasNarrowBottom = _ref.hasNarrowBottom,
      hasNarrowBottom = _ref$hasNarrowBottom === void 0 ? false : _ref$hasNarrowBottom,
      _ref$hasLargeBottom = _ref.hasLargeBottom,
      hasLargeBottom = _ref$hasLargeBottom === void 0 ? false : _ref$hasLargeBottom,
      className = _ref.className,
      children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, isAgentAvailable && /*#__PURE__*/_react.default.createElement(_Available.default, {
    isAgentAvailable: isAgentAvailable
  }), hasErrorMark && /*#__PURE__*/_react.default.createElement(_ExclamationTriangle.default, null), hasSuccessMark && /*#__PURE__*/_react.default.createElement(_SuccessMark.default, null), /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    fontWeight: 600,
    variant: "h3",
    fontSize: "21px"
  }, props), children));
};

Title.propTypes = {
  isAgentAvailable: _propTypes.default.bool,
  hasErrorMark: _propTypes.default.bool,
  hasSuccessMark: _propTypes.default.bool,
  hasNarrowBottom: _propTypes.default.bool,
  hasLargeBottom: _propTypes.default.bool,
  className: _propTypes.default.string,
  children: _propTypes.default.any.isRequired
};

var _default = (0, _styledComponents.default)(Title).withConfig({
  displayName: "Title",
  componentId: "g75jem-0"
})(["margin-bottom:30px;", " ", ""], function (props) {
  return props.hasNarrowBottom && (0, _styledComponents.css)(["margin-bottom:15px;"]);
}, function (props) {
  return props.hasLargeBottom && (0, _styledComponents.css)(["margin-bottom:40px;"]);
});

exports.default = _default;